import { gql } from 'src/__generated__'

export default gql(`
  mutation forgotPasswordConfirm($data: ForgotPasswordConfirmInput!) {
    forgotPasswordConfirm(data: $data)
  }
`)
